import { Stack } from '@chakra-ui/react';

const LABEL_WIDTH_VARIABLE = '--field-label-width';
const LABEL_COLUMN_WIDTH = '180px';

const VFormColumnHorizontal = ({ children, css = undefined, ...props }) => (
  <Stack css={{ [LABEL_WIDTH_VARIABLE]: LABEL_COLUMN_WIDTH, ...css }} {...props}>
    {children}
  </Stack>
);

export default VFormColumnHorizontal;
